import React from 'react'
import * as css from './redirect.scss'

const Redirect = () => <div className={css.container} />

export default Redirect
